export const INLINE_CUSTOM_STREAM_TARGET_LIMIT = 3;

export const inlineCustomStreamTargets = <T>(targets: readonly T[]) => {
  const visible = targets.slice(0, INLINE_CUSTOM_STREAM_TARGET_LIMIT);
  return {
    visible,
    hiddenCount: targets.length - visible.length,
  };
};

export const inlineCustomStreamTargetsMoreLabel = (hiddenCount: number) =>
  hiddenCount > 0 ? `${hiddenCount} more` : null;
